module.exports = __webpack_public_path__ + "static/img/t1-3.991a014.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/en/t1-3.png
// module id = 8mvy
// module chunks = 1